// extracted by mini-css-extract-plugin
module.exports = {"container":"text-page_container__CSx4Z"};